/**
 * @module wishlist
 * @description
 * This module contains the logic for the wishlist page.
 * It allows the user to remove items from the wishlist, view product details, update the wishlist item,
 * toggle the public status of the wishlist, and add items to the cart.
 * It also allows the user to view more items in the wishlist,
 * copy the wishlist link, and submit a search for a wishlist.
 * It also allows the user to view more search results.
 */
import { createCustomDropdown } from '@project/components/customSelect';
import {
    handlePostCartAdd,
    miniCartReportingUrl,
} from '@assets/product/base';
import { createErrorNotification } from '@project/cart/cart';
import { replaceQueryParam } from '@project/components/utility';

/**
 * @function updateWishlistTotal
 * @description
 * Updates the wishlist total in the header
 * @param {Object} data - the data object
 */
export function updateWishlistTotal(data) {
    $('.wishlist-total').text(data.total);
}
export default class Wishlist {
    constructor() {
        this.handlePostCartAdd = handlePostCartAdd;
        this.body = $('body');
    }

    init() {
        this.addToCartFromWishlist();
        const self = this;
        this.createWishlistDropdown();
        this.updateAttribute();
        this.body.on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            const url = $(this).data('url');
            const $item = $(this).closest('.wishlist-account-card.card');
            self.removeFromWishlist(url, $item);
        });
    }

    removeFromWishlist(url, $item) {
        const wishlistItems = $('.wishlist-account-card.card');
        if (wishlistItems.length > 0) {
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                data: {},
                success(data) {
                    $item.remove();
                    updateWishlistTotal(data);
                    if (data.total === 0) {
                        window.location.reload();
                    }
                },
                error(e) {
                    console.error(e);
                },
            });
        }
    }

    updateAttribute() {
        this.body.on('product:afterAttributeSelect', (e, response) => {
            const $inputUpdater = response.container.find(
                '.update-wishlist-url',
            );
            const updateProductUrl = $inputUpdater.val();
            const uuid = $inputUpdater.data('uuid');
            const pid = response.container.find('option:selected').data('pid');
            const form = {
                uuid,
                pid,
                selectedOptionValueId: pid,
            };
            response.container.data('pid', response.data.product.id);
            response.container
                .find('.add-to-cart-wishList')
                .toggleClass('already-in-cart', response.data.isInCart);
            response.container
                .find('.add-to-cart')
                .data('pid', response.data.product.id)
                .toggleClass('not-ready', !response.data.product.readyToOrder);
            this.body.trigger('wishlist:beforeUpdate');
            const removeButton = response.container.find(
                '.remove-from-wishlist',
            );
            const newID = response.data.product.id;
            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success(data) {
                        removeButton.data(
                            'url',
                            replaceQueryParam(
                                removeButton.data('url'),
                                'pid',
                                newID,
                            ),
                        );
                        $('body').trigger('wishlist:afterUpdate', data);
                    },
                    error(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(
                                err.responseJSON.errorMessage,
                            );
                        }
                    },
                });
            }
        });
    }

    addToCartFromWishlist() {
        // decomment all commented line of this method to reenable
        // removeFromWishlist after add to cart
        const self = this;
        this.body.on('click', '.add-to-cart-global', function (e) {
            if ($(this).hasClass('not-ready')) {
                e.stopImmediatePropagation();
                $(this)
                    .closest('.card')
                    .find('.custom-options-container')
                    .addClass('open');
            } else {
                self.body.trigger('product:beforeAddToCart', this);
                const pid = $(this).data('pid');
                const addToCartUrl = $(this).data('url');
                const pidsQty = 1;
                // const removeFromWishlistUrl = $(this).closest('.card').find('.remove-from-wishlist').data('url');
                // const $removeFromWishlistItem = $(this).closest('.wishlist-account-card.card');
                const form = {
                    pid,
                    quantity: pidsQty,
                };

                if ($(this).data('option')) {
                    form.options = JSON.stringify($(this).data('option'));
                }
                const $ctasContainer = $(this).closest('.add-to-cart-wishList');
                $ctasContainer.find('.button').attr('disabled', true);
                $(this).trigger('updateAddToCartFormData', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success(data) {
                            handlePostCartAdd(data);
                            $('body').trigger('product:afterAddToCart', data);
                            miniCartReportingUrl(data.reportingURL);
                            $ctasContainer.addClass('already-in-cart');
                            // self.removeFromWishlist(removeFromWishlistUrl, $removeFromWishlistItem);
                        },
                        error(error) {
                            console.error(error);
                        },
                        complete() {
                            $ctasContainer.find('.button').attr('disabled', false);
                        },
                    });
                }
            }
        });
    }

    createWishlistDropdown() {
        const $allSelect = $('.custom-select select');
        $allSelect.each((i, select) => {
            createCustomDropdown($(select));
        });
    }
}
